import { IFeaturedItem } from '../../models/featurered-item';
import { IResult } from '../../models/result-models';
import {
    LOAD_FEATURED_ITEMS_ERROR,
    LOAD_FEATURED_ITEMS_SUCCESS,
} from './featured-item-actions';

interface LoadFeaturedItemsSuccessAction {
    type: 'LOAD_FEATURED_ITEMS_SUCCESS';
    payload: IResult<IFeaturedItem[]>;
}

interface LoadFeaturedItemsErrorAction {
    type: 'LOAD_FEATURED_ITEMS_ERROR';
    payload: IResult<IFeaturedItem[]>;
}

type KnownAction =
    | LoadFeaturedItemsSuccessAction
    | LoadFeaturedItemsErrorAction;

export const featuredIemReducer = (
    state: IResult<IFeaturedItem[]> | null = null,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_FEATURED_ITEMS_SUCCESS:
            return action.payload;
        case LOAD_FEATURED_ITEMS_ERROR: {
            const result: IResult<IFeaturedItem[]> = {
                ...action.payload,
                data: state ? state.data : null,
            };
            return result;
        }
        default:
            return state;
    }
};
